import { gql } from '@/__generated__';
import { useQuery } from '@apollo/client';
import { ActionIcon, Group, Paper, Stack, Text } from '@mantine/core';
import { IconPrinter, IconRefresh } from '@tabler/icons-react';
import { DataTable } from 'mantine-datatable';
import { useState } from 'react';

const liveUnprintedLabelsDocument = gql(/* GraphQL */ `
  query LiveUnprintedLabelsDocument($live: LiveWhereInput!, $skip: Int, $take: Int) {
    liveUnprintedLabels(live: $live, skip: $skip, take: $take) {
      total
      orders {
        id
        package
        customer {
          id
          name
        }
      }
    }
  }
`);

export const LivePackagesTable = ({ liveId }: { liveId: string }) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);

  const { data, loading, refetch } = useQuery(liveUnprintedLabelsDocument, {
    variables: {
      live: { id: { equals: liveId } },
      skip: pageSize * page - pageSize,
      take: pageSize,
    },
    pollInterval: 10 * 1000,
  });

  const records = data?.liveUnprintedLabels.orders.map((order) => ({
    id: order.id,
    package: order.package,
    customer: order.customer.name,
  }));

  return (
    <Paper p="md" withBorder component={Stack}>
      <Group justify="space-between">
        <Text>Nové balíky</Text>
        <Group>
          <ActionIcon
            variant="filled"
            onClick={() => {
              void refetch();
            }}
            loading={loading}
          >
            <IconRefresh size={16} />
          </ActionIcon>
          <ActionIcon
            variant="filled"
            color="teal"
            component="a"
            href={`https://api.laskykrasky.sk/api/live/labels?liveId=${liveId}`}
            target="_blank"
          >
            <IconPrinter size={16} />
          </ActionIcon>
        </Group>
      </Group>
      <DataTable
        withTableBorder
        striped
        highlightOnHover
        borderRadius="sm"
        height={552}
        fetching={loading}
        totalRecords={data?.liveUnprintedLabels.total}
        recordsPerPage={pageSize}
        page={page}
        onPageChange={setPage}
        recordsPerPageOptions={[5, 10, 25, 50, 100]}
        onRecordsPerPageChange={setPageSize}
        records={records ?? []}
        columns={[
          { accessor: 'package', title: 'Balík' },
          { accessor: 'customer', title: 'Zákazník' },
        ]}
      />
    </Paper>
  );
};
